<template>
  <div class="d-flex flex-column">
    <div class="row justify-content-start mb-4">
      <div class="col-12 col-sm-4 mb-3">
        <BarChart
          v-if="!getLoading"
          :labels="hoursGraphLabels"
          :datasets="alarmsGraphDatasets"
          :title="$t('sections.alarmsmLandingPage.alarmsGraphTitle')"
        />
      </div>
    </div>
  </div>
</template>
<script>
import { mapGetters } from 'vuex';
import BarChart from '@/components/ui/charts/BarChart.vue';

export default {
  name: 'AlarmsManagerLandingPage',
  components: {
    BarChart,
  },
  data() {
    return {
      hoursGraphLabels: [],
      alarmsBySatusValuesNew: [],
      alarmsBySatusValuesResolved: [],
    };
  },
  computed: {
    ...mapGetters([
      'getLoading',
    ]),
    alarmsGraphDatasets() {
      return [
        {
          label: this.$t('sections.alarmsmLandingPage.newAlarms'),
          borderColor: '#1a84cf',
          backgroundColor: 'rgba(26, 132, 207, 0.5)',
          data: this.alarmsBySatusValuesNew,
        },
        {
          label: this.$t('sections.alarmsmLandingPage.resolvedAlarms'),
          borderColor: '#56a3e0',
          backgroundColor: 'rgba(86, 163, 224, 0.5)',
          data: this.alarmsBySatusValuesResolved,
        },
      ];
    },
  },
  mounted() {
    this.fetchData();
  },
  methods: {
    async fetchData() {
      this.$store.dispatch('storeLoading', true);

      const analytics = await this.$store.dispatch('getAlarmsAnalytics');
      analytics.sortedAlarmsByDay.forEach((element) => {
        this.hoursGraphLabels.push(element.day);
        let newCount = 0;
        let resolvedCount = 0;
        element.statuses.forEach((status) => {
          if (status.status === 'New') {
            newCount = status.count;
          } else if (status.status === 'Resolved') {
            resolvedCount = status.count;
          }
        });
        this.alarmsBySatusValuesNew.push(newCount);
        this.alarmsBySatusValuesResolved.push(resolvedCount);
      });

      this.$store.dispatch('storeLoading', false);
    },
  },
};
</script>
